<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { debug, mainMenu } from '../../../stores/store';
    import { api } from '../../../stores/api';
    import { app } from '../../../stores/app';
    import MainMenuVerticalElement from './MainMenuVerticalElement.svelte';
    import IconLeftPanelClose from '../Icons/IconLeftPanelClose.svelte';
    import IconLeftPanelOpen from '../Icons/IconLeftPanelOpen.svelte';
    import { LocationApi } from '../../components/Location/LocationApi';
    import { ConnectionApi } from '../../components/Connection/ConnectionApi';
    import { RoutesApi } from '../../components/Connection/Routes/RoutesApi';
    import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';

    interface NotificationRequest {
        item: any,
        promise: Promise<any>|null,
        handler: Function|null
    };

    let currentNotifications: any = {};

    function onNotificationUpdate(id: string, notification: any) {
        currentNotifications[id] = notification;
        $mainMenu.items[$mainMenu.items.findIndex((i) => i.id === id)].notification = notification;
        if ($mainMenu.autoShowNotification) {
            let pending = Object.values(currentNotifications).filter((n:any) => n.pending === true);
            if (pending.length == 0) {
                let topNotification: any = null;
                for (let i in currentNotifications) {
                    let itemIndex = $mainMenu.items.findIndex((it) => it.id === i);
                    if ($mainMenu.items[itemIndex].notification) {
                        $mainMenu.items[itemIndex].notification.showAuto = false;
                        if (currentNotifications[i].priority && ($mainMenu.autoShowNotification === true || currentNotifications[i].priority <= $mainMenu.autoShowNotification)) {
                            if (topNotification === null || topNotification.notification.priority < currentNotifications[i].priority) {
                                topNotification = {id: i, notification: currentNotifications[i]};
                            }
                        }
                    }
                }
                if (topNotification) {
                    let itemIndex = $mainMenu.items.findIndex((i) => i.id === topNotification.id);
                    if ($mainMenu.items[itemIndex].notification) {
                        $mainMenu.items[itemIndex].notification.showAuto = true;
                    }
                    $mainMenu.autoShowNotification = topNotification.notification.priority;
                }
            }
        }
        $mainMenu = $mainMenu;
    }

    $: {
        // FIXME: dirty hack -- remove $app
        let notificationRequests: NotificationRequest[] = [];
        $mainMenu.items.forEach(item => {
            if ((item.id === 'PageWorkshop' || item.id === 'PageStart') && $app.isAdmin) {
                item.visibleInMenu = $debug;
                item.visible = $debug;
            }
            if (item.id === 'PageAdmin' && $app.isAdmin) {
                item.visible = true;
                item.visibleInMenu = true;
            }
            if (item.id === 'PageUserPermissions' && $app.permissions?.isUserManager) {
                item.visible = true;
                item.visibleInMenu = true;
            }
            if (item.visibleInMenu && item.notification?.reload) {
                let itemIndex = $mainMenu.items.findIndex((i) => i.id === item.id);
                item.notification.reload = false;
                item.notification.priority = 0;
                $mainMenu.items[itemIndex].notification = item.notification;
                currentNotifications[item.id] = {...item.notification, pending: true};
                let promise = null;
                let handler = null;
                switch (item.id) {
                    case 'PageJobs':
                        if (!$app.settingsReadonly?.allow_limit_exceeding && $app.settingsReadonly?.max_locations !== null) {
                            promise = LocationApi.getCountWithQueries($api, {}, new ApiFilterBuilder(1));
                            handler = (item: any, response: any) => {
                                if (response.count >= $app.settingsReadonly?.max_locations) {
                                    item.notification.priority = 100;
                                    item.notification.type = 'warning';
                                    item.notification.text = $_('location_limit_exceeded', {values: {current: response.count, limit: $app.settingsReadonly?.max_locations}});
                                } else if (response.count >= 0.9 * $app.settingsReadonly?.max_locations) {
                                    item.notification.priority = 90;
                                    item.notification.type = 'notice';
                                    item.notification.text = $_('location_limit_approaching', {values: {current: response.count, limit: $app.settingsReadonly?.max_locations}});
                                } else {
                                    item.notification.type = 'none';
                                }
                                return item;
                            };
                        }
                        break;
                    case 'PageConnection':
                        if (!$app.settingsReadonly?.allow_limit_exceeding && ($app.settingsReadonly?.max_connections !== null || $app.settingsReadonly?.max_transactions_per_month !== null)) {
                            promise = Promise.all([
                                ConnectionApi.getCountWithQueries($api, {}, new ApiFilterBuilder(1)),
                                RoutesApi.getCurrentTransactionCount($api)
                            ]);
                            handler = (item: any, response: any) => {
                                item.notification.text = '';
                                if (($app.settingsReadonly?.max_connections && response[0].count >= $app.settingsReadonly?.max_connections) || ($app.settingsReadonly?.max_transactions_per_month && response[1].count >= $app.settingsReadonly?.max_transactions_per_month)) {
                                    item.notification.priority = 100;
                                    item.notification.type = 'warning';
                                    if ($app.settingsReadonly?.max_connections && response[0].count >= $app.settingsReadonly?.max_connections) {
                                        item.notification.text += '<div>'+$_('connection_limit_exceeded', {values: {current: response[0].count, limit: $app.settingsReadonly?.max_connections}})+'</div>';
                                    }
                                    if ($app.settingsReadonly?.max_transactions_per_month && response[1].count >= $app.settingsReadonly?.max_transactions_per_month) {
                                        item.notification.text += '<div>'+$_('transaction_limit_exceeded', {values: {current: response[1].count, limit: $app.settingsReadonly?.max_transactions_per_month}})+'</div>';
                                    }
                                } else if (($app.settingsReadonly?.max_connections && response[0].count >= 0.9 * $app.settingsReadonly?.max_connections) || ($app.settingsReadonly?.max_transactions_per_month && response[1].count >= 0.9 * $app.settingsReadonly?.max_transactions_per_month)) {
                                    item.notification.priority = 90;
                                    item.notification.type = 'notice';
                                    if ($app.settingsReadonly?.max_connections && response[0].count >= 0.9 * $app.settingsReadonly?.max_connections) {
                                        item.notification.text += '<div>'+$_('connection_limit_approaching', {values: {current: response[0].count, limit: $app.settingsReadonly?.max_connections}})+'</div>';
                                    }
                                    if ($app.settingsReadonly?.max_transactions_per_month && response[1].count >= 0.9 * $app.settingsReadonly?.max_transactions_per_month) {
                                        item.notification.text += '<div>'+$_('transaction_limit_approaching', {values: {current: response[1].count, limit: $app.settingsReadonly?.max_transactions_per_month}})+'</div>';
                                    }
                                } else {
                                    item.notification.type = 'none';
                                }
                                return item;
                            };
                        }
                        break;
                }
                notificationRequests.push({item: item, promise: promise, handler: handler});
            }
        });
        if (notificationRequests.length) {
            Promise.all(notificationRequests.map((r) => r.promise)).then((response) => {
                for (let i = 0; i < response.length; i++) {
                    let request = notificationRequests[i];
                    if (typeof(request.handler) == 'function') {
                        let item = request.handler(request.item, response[i]);
                        onNotificationUpdate(item.id, item.notification);
                    }
                }
                $mainMenu = $mainMenu;
            });
        }
        $mainMenu = $mainMenu;
    }
</script>

<div class="menu-container" class:expanded={$mainMenu.expanded}>
    <div class="menu-tab">
        <div class="menu-item-list-start">
            {#each $mainMenu.items.filter(item => item.side !== 'right' && item.visibleInMenu) as item, index (item.id)}
                <MainMenuVerticalElement {item} />
            {/each}
        </div>
        <div class="menu-item-list-end">
            {#each $mainMenu.items.filter(item => item.side === 'right' && item.visibleInMenu) as item, index (item.id)}
                <MainMenuVerticalElement {item} />
            {/each}
        </div>
        <div
            class="menu-visibility-toggle"
            on:click={() => {
                $mainMenu.expanded = !$mainMenu.expanded;
            }}
        >
            {#if $mainMenu.expanded}
                <IconLeftPanelClose />
            {:else}
                <IconLeftPanelOpen />
            {/if}
        </div>
    </div>
</div>

<style>
    :root {
        --border-color: #f2f2f2;
    }
    .menu-container {
        display: flex;
        height: 100%;
        flex-direction: column;
    }
    .menu-container.expanded {
        width: 180px;
        /*transition: 0.3s;*/
    }
    .menu-tab {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 1fr 1fr 40px;
        grid-template-areas:
            'menu-items-start'
            'menu-items-end'
            'menu-visibility-toggle';
        /*display: flex;*/
        /*justify-content: space-between;*/
        /*flex-direction: column;*/
        padding: 0 0 0 0;
        /*border-right: 4px solid #d4d4d488;*/
        border-right: 4px solid var(--border-color);
        background-color: white;
        width: 100%;
        height: 100%;
    }
    .menu-item-list-start {
        grid-area: menu-items-start;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        column-gap: 10px;
        padding: 26px 6px 6px 6px;
        row-gap: 5px;
    }
    .menu-item-list-end {
        grid-area: menu-items-end;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        column-gap: 10px;
        padding: 6px 6px 26px 6px;
        row-gap: 5px;
    }
    .menu-visibility-toggle {
        grid-area: menu-visibility-toggle;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        background-color: var(--border-color);
    }
    .menu-visibility-toggle :global(.icon) {
        opacity: 0.3;
    }
    .menu-visibility-toggle:hover {
        background-color: var(--main-selected-background);
        color: var(--main-selected-color);
    }
    .menu-visibility-toggle:hover :global(.icon) {
        opacity: 1;
    }
</style>
